import { InjectionToken } from '@angular/core';

export const DEBUG = new InjectionToken<string>('debug');
export const FEATURE_CLIENT_ID = new InjectionToken<string>('featureClientId');
export const SMART_FILL = new InjectionToken<string>('smartFill');
export const EXPORT_NOTIFICATION = new InjectionToken<string>(
  'exportRowsNotification',
);
export const WEBHOOK_ID = new InjectionToken<string>('webhookRecipientId');

export const APP_VERSION = new InjectionToken<string>('appVersion');
export const PRODUCT = new InjectionToken<string>('product');

export const GLOBAL_SERVICES_URL = new InjectionToken<string>(
  'globalServicesUrl',
);
export const GLOBAL_SERVICES_KEY = new InjectionToken<string>(
  'globalServicesKey',
);
export const OAUTH2_CLIENT_ID = new InjectionToken<string>('oauth2ClientId');
export const OAUTH2_CLIENT_ID_EMEA = new InjectionToken<string>(
  'oauth2ClientIdEmea',
);

export const N8N_BASE_URL = new InjectionToken<string>('baseUrl');

export const N8N_ONBOARDING_TRIAL_IMPORT_ID = new InjectionToken<string>(
  'trialImportDataId',
);

export const N8N_TRIAL_USERS_CONVERT_ID = new InjectionToken<string>(
  'convertTrialUserId',
);

export const APPSTORE_ORIGIN = new InjectionToken<string>('appStoreOrigin', {
  factory: () => '',
});
